import React from "react";

import { withConfiguration, withSession } from "../../context";
import { addAccessTokenToLcmApiUrl } from "../../utils";
import Icon from "../Icon";

type OwnProps = {
  src?: string;
  alt?: string;
  token?: string;
  lcmApiUrl?: string;
  placeholder?: string;
  width?: number;
  height?: number;
  configuration: {
    lcmApiUrl?: string;
  };
  session: {
    token?: string;
  };
};

const defaultProps: Partial<OwnProps> = {
  placeholder: "icon-eh-device",
  width: 200,
  height: 200,
};

type Props = OwnProps & typeof defaultProps;

export function Picture({
  alt,
  session,
  placeholder,
  width,
  height,
  src,
  configuration,
}: Props) {
  const style = { width: `${width}px`, height: `${height}px` };

  const [errorLoadingImage, setErrorLoadingImage] = React.useState(false);

  return src && !errorLoadingImage ? (
    <img
      src={addAccessTokenToLcmApiUrl(
        src,
        configuration.lcmApiUrl,
        session.token,
      )}
      alt={alt}
      onError={
        /* istanbul ignore next */
        () => {
          setErrorLoadingImage(true);
        }
      }
      style={style}
    />
  ) : (
    <div className="list-item-icon placeholder">
      <Icon name={placeholder} />
    </div>
  );
}

Picture.defaultProps = defaultProps;

export default withConfiguration(withSession(Picture));
